/**
 * Some tool names don't follow simple title-case rules (acronyms, stylized
 * capitalization). Keyed by the raw upstream value, case-insensitively.
 */
const TOOL_NAME_OVERRIDES: Record<string, string> = {
  'CROWDSTRIKE IOM': 'CrowdStrike IOM',
  XMCO: 'XMCO',
  CODEQL: 'CodeQL',
  DEFSEC: 'defsec',
  MOBSFSCAN: 'MobSFScan',
  SONARQUBE: 'SonarQube',
  UPGUARD: 'UpGuard',
  'HACKERONE REPORT': 'HackerOne',
};

/**
 * `issue_type` (displayed to users as "Tool") arrives from upstream
 * ingestion as a shouty-case label (`ORCA ALERTS`, `CROWDSTRIKE IOM`). This
 * only affects display — filter values, drill-down codes, and chart/table
 * data keys must keep comparing the raw shouty-case string.
 *
 * Falls back to simple title-casing for any tool name without a special
 * case above. `single_view.sql`/`asset_details.sql` (unlike the
 * rollup/dropdown queries) don't filter out a null `issue_type`, so this
 * tolerates a nullish value rather than assuming the raw table has already
 * screened for one.
 */
export const formatToolName = (value: string | null | undefined): string => {
  if (!value) return '';
  const override = TOOL_NAME_OVERRIDES[value.toUpperCase()];
  if (override) return override;
  return value
    .toLowerCase()
    .replace(/[-_\s]+/g, ' ')
    .replace(/(^|\s)\S/g, char => char.toUpperCase());
};
